import { create } from 'zustand';
import { Team } from '../types';
import { teamService } from '../services/api';

interface TeamsState {
  teams: Team[];
  loading: boolean;
  lastFetched: number | null;

  fetchTeams: (force?: boolean) => Promise<void>;
  setTeams: (teams: Team[]) => void;
  updateTeam: (team: Team) => void;
  addTeam: (team: Team) => void;
  removeTeam: (teamId: string) => void;
}

export const useTeamsStore = create<TeamsState>()((set, get) => ({
  teams: [],
  loading: false,
  lastFetched: null,

  fetchTeams: async (force?: boolean) => {
    const { lastFetched, loading } = get();
    if (!force && lastFetched && Date.now() - lastFetched < 30000) return;
    if (loading) return;

    set({ loading: true });
    try {
      const data = await teamService.getAllTeams(!force);
      set({ teams: data, lastFetched: Date.now() });
    } catch (error) {
      console.error('Error fetching teams:', error);
    } finally {
      set({ loading: false });
    }
  },

  setTeams: (teams) => set({ teams, lastFetched: Date.now() }),

  updateTeam: (team) =>
    set((state) => ({
      teams: state.teams.map((t) => (t._id === team._id ? team : t)),
    })),

  addTeam: (team) =>
    set((state) => {
      if (state.teams.some((t) => t._id === team._id)) {
        return { teams: state.teams.map((t) => (t._id === team._id ? team : t)) };
      }
      return { teams: [...state.teams, team] };
    }),

  removeTeam: (teamId) =>
    set((state) => ({
      teams: state.teams.filter((t) => t._id !== teamId),
    })),
}));
